import { motion } from 'framer-motion';

const Hero = () => {
  const handleAgendar = () => {
    window.open("https://wa.me/5563991352552?text=Olá%2C%20gostaria%20de%20agendar%20uma%20consulta.", "_blank");
  };

  return (
    <section id="home" className="min-h-screen flex items-center pt-20 bg-gradient-to-br from-secondary/30 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20">
        <div className="flex flex-col md:flex-row items-center gap-12">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            className="flex-1 text-center md:text-left"
          >
<div className="mb-6">
<h1 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold leading-tight mb-6">
  <span className="text-textLight">Cuidando da sua</span>
  <br />
  <span className="text-primary text-4xl md:text-5xl lg:text-6xl">saúde íntima</span><br />
  <span className="text-textDark"> com acolhimento,</span>
  <br />
  <span className="text-textDark">equilíbrio hormonal e respeito</span>
  <br />
  <span className="text-textLight">em cada fase da sua vida</span>
</h1>
</div>
            <p className="text-lg text-textLight mb-4">
              Equilíbrio hormonal em cada fase da sua vida
            </p>
            <p className="text-sm text-textLight mb-8">
              CRM 3443 • RQE 2611 (Ginecologia/Obstetrícia)
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
              <button
                onClick={handleAgendar}
                className="bg-primary text-white px-8 py-3 rounded-full font-semibold hover:bg-primaryDark transition-all duration-300 hover:scale-105"
              >
                Agendar consulta
              </button>
              <a 
                href="#areas" 
                className="border-2 border-primary text-primary px-8 py-3 rounded-full font-semibold hover:bg-primary hover:text-white transition-all text-center"
              >
                Conhecer tratamentos
              </a>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="flex-1"
          >
            <div className="relative">
              <div className="absolute -top-4 -right-4 w-72 h-72 bg-primary/10 rounded-full blur-3xl"></div>
              <img
                src="/assets/images/IMG_0924.jpg"
                alt="Dra. Fernanda Palhares"
                className="relative w-full max-w-md mx-auto rounded-2xl shadow-2xl object-cover border-4 border-white"
                onError={(e) => {
                  console.error("Erro ao carregar imagem:", e.target.src);
                  e.target.src = "https://via.placeholder.com/500x500?text=Foto+Dra.+Fernanda";
                }}
              />
              <div className="absolute -bottom-6 -left-6 bg-white rounded-xl shadow-lg p-4">
                <div className="flex items-center gap-3">
                  <div className="w-3 h-3 bg-green-500 rounded-full animate-pulse"></div>
                  <span className="text-sm font-semibold text-textDark">Atendimento Humanizado</span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;